export const RECEIVE_USER = 'RECEIVE_USER'
export const LOGOUT = 'LOGOUT'
export const RECEIVE_AUTH_ERROR = 'RECEIVE_AUTH_ERROR'
